import React from "react";
import {Box} from "@mui/system";
import {ListItemText} from "@mui/material";
import dayjs from "dayjs";
import {useTranslation} from "react-i18next";

const  ListItemSecondaryActionTime = ({time, row = false, sx}) => {
	const {t} = useTranslation();

	const isTodayOrYesterdayPrimary = (time) => {
		if (dayjs(time).isToday()) return t("Today");
		else if (dayjs(time).isYesterday()) return t("Yesterday");
		else return dayjs(time).format("DD.MM.YYYY");
	};

	const isTodayOrYesterdaySecondary = (time) => {
		const dj = dayjs(time);
		if (dj.isToday() || dj.isYesterday() ) return dj.format("HH:mm");
		else return dj.format("ddd HH:mm");
	};

	return (
		<Box id={"lvl1"}>
			{row ?
				<Box id={"lvl2"} sx={{...sx}}>
					<ListItemText
						slotProps={{
							primary: {
								display: "flex",
								justifyContent: "end",
								fontSize: "12px"
							}
						}}
					>
						{`${isTodayOrYesterdayPrimary(time)} ${isTodayOrYesterdaySecondary(time)}`}
					</ListItemText>
				</Box>
				:
				<Box id={"lvl2"} sx={{display: "flex", flexDirection: "column", ...sx}}>
					<ListItemText
						slotProps={{
							primary: {
								display: "flex",
								justifyContent: "end",
								fontSize: "12px"
							}
						}}
					>
						{isTodayOrYesterdayPrimary(time)}
					</ListItemText>
					<ListItemText
						slotProps={{
							primary: {
								display: "flex",
								justifyContent: "end",
								fontSize: "12px"
							}
						}}
					>
						{isTodayOrYesterdaySecondary(time)}
					</ListItemText>
				</Box>
			}
		</Box>
	);
};

export default ListItemSecondaryActionTime;
